import { Location } from '@angular/common';
import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ResponseHandler } from '@app/_core/helper/ResponseHandler';
import { ManagerService } from '@app/_core/services/manager.service';
import { SecurityService } from '@app/_core/services/security.service';
import { WebStorageService } from '@app/_core/services/webstorage.service';
import { environment } from '@environments/environment';
import { catchError, EMPTY, map } from 'rxjs';
import { AgentStatus } from '@app/_core/helper/AgentStatus';
import { Utils } from '@app/_core/helper/Utils';
import { ConfirmDialogComponent } from 'src/app/pages/common/confirm-dialog/confirm-dialog.component';
import { MainControllerComponent } from 'src/app/pages/queue/dialer/MainController.component';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { ManagerLiveMoniterComponent } from '@app/pages/console/livestatuses/manager-live-moniter/manager-live-moniter.component'
import { WindowsWrapper } from '../../../../app.config';
import { LoaderService } from '@app/_core/services/loader.service';
@Component({
    selector: 'app-livestatus-details',
    templateUrl: './livestatus-details.component.html',
    styleUrls: ['./livestatus-details.component.scss'],
    encapsulation: ViewEncapsulation.Emulated
})
export class LivestatusDetailsComponent implements OnInit {
    agentDetail: any;
    modalRef?: BsModalRef;
    debugMode = false;
    canLiveView = false;
    title: string = '';
    selectedInteractionId: any;
    selectedAgentId: any;
    skillDetails: any;
    modifiedQueueData: any;
    modifiedSkillData: any;
    queueDetails: any;

    ManageAssignments = false;
    AuditAgents = false;
    ManageAgents = false;
    Admin = false;
    canStatusBeLoggedOff: any;
    isAgentUsingWrapper = false;
    isManagerUsingWrapper = false;
    isLiveViewing = false;
    isListeningIn = false;
    isCallActive = false;
    isConnecting = false;
    liveStatusWaitShort = 5000;
    liveStatusWaitLong = 10000;
    liveStatusTimer;
    currStatusLabel: string = 'LogOut';
    agentStatusDuration: string = '';
    agentStatusColor: string = '';
    liveStatusControls: boolean;
    managerViewBtn = false;
    managerHideBtn = false;
    managerListenBtn = false;
    managerDisconnectBtn = false;
    managerRemoteLogoffBtn = false;
    managerMuteOnBtn = false;
    managerMuteOffBtn = false;
    CurrentAgent: any;
    currStatus: any;
    isMuted = false;
    isPhoneQueue = false;
    clientAbbr: any;
    WrapperOnvida: any;
    interactionHeader: string = "LAST INTERACTION";
    queueHeader: string = "CURRENT QUEUE";
    extensionValue:any;
    editErrorMessage: any;
    showExtensionErrorMsg: boolean = false;
    isCustomLabel: boolean = false;
    CurrentStatus: boolean =false;
    isDesktopOnly: boolean = false;
    allowPopUps: boolean = true;
    isEnabled: boolean = false; // New property to control checkbox enable/disable

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private managerService: ManagerService,
        private securityService: SecurityService,
        private location: Location,
        private webStorageService: WebStorageService,
        private agentStatus: AgentStatus,
        private utils: Utils,
        private confirmDialogComponent: ConfirmDialogComponent,
        private mainController: MainControllerComponent,
        public bsModalRef: BsModalRef,
        private modalService: BsModalService,
        private loaderService: LoaderService,
        @Inject(WindowsWrapper) private OnvidaWrapper: any
    ) {
        this.route.params.subscribe((params: any) => {
            this.reset();
          //  console.log(params);
            this.selectedInteractionId = params.id;
            this.selectedAgentId = params.id;
            this.GetLiveStatusByID(params.id);
            this.getAgentCustomAccess(params.id);
        });
    }

    ngOnInit(): void {
        this.debugMode =
            environment.environment == 'DEV' || environment.environment == 'STAGE' || environment.environment == 'TEST';
        this.fetchGrands();
    }
    GetLiveStatusByID(id: number) {
        this.managerService
            .GetLiveStatusByID(id)
            .pipe(
                map((data: any) => {
                    const isValid = ResponseHandler.processResponse(data, 'GetLiveStatusByID');
                    if (isValid) {
                        
                        this.updateLiveStatus(data.Response.Data['LiveStatus']);
                        this.agentDetail = data.Response.Data;
                        this.title = 'Agent ' + this.agentDetail.ID + ' - ' + this.agentDetail.Name;
                        this.queueDetails = {
                            ID: this.agentDetail.ID,
                            owner: 'agent',
                            object: 'queue',
                            service: this.managerService,
                            method: 'GetAgentQueues',
                            priorities: false,
                            persistence: false,
                            roles: false,
                            disable: undefined,
                        };

                        this.skillDetails = {
                            ID: this.agentDetail.ID,
                            owner: 'agent',
                            object: 'skill',
                            service: this.managerService,
                            method: 'GetAgentSkills',
                            priorities: true,
                            persistence: true,
                            roles: false,
                            disable: undefined,
                        };
                        
                    }
                }),
                catchError(error => {
                    console.log(error);
                    return EMPTY;
                })
            )
            .subscribe();
    }


    getAgentCustomAccess(id: number) {
        this.managerService.AgentCustomAccess(id)
            .subscribe(res => {
                this.allowPopUps = res?.AllowPopup;
                this.isDesktopOnly = res?.WrapperOnly;
                this.isEnabled = true; // Enable checkboxes after fetching access rights
            });
    }
    goBack() {
        this.reset();
        this.location.back();
    }
 
    saveChanges() {
       // console.log(this.extensionValue,'exten');
        this.extensionValue = this.extensionValue ? this.extensionValue : this.agentDetail.Extension;
        const queues = [];
        const skills = [];


        if (this.modifiedQueueData?.length > 0) {
            for (const queue of this.modifiedQueueData) {
                queues.push(queue.ID);
            }
        }
        if (this.modifiedSkillData?.length > 0) {
            for (const skill of this.modifiedSkillData) {
                const priority = skill.Priority == null ? '0' : skill.Priority;
                const status = skill.ID + '|' + priority + '|' + skill.Persistent;
                skills.push(status);
            }
        }
        if (this.extensionValue != '') {
        if (isNaN(this.extensionValue)) {
            this.editErrorMessage= ''
            this.showExtensionErrorMsg = true;
            return;
           
        } else {
            this.showExtensionErrorMsg = false;
        
            const data = {
                capResults: true,
                id: this.agentDetail.ID,
                ext:this.extensionValue,
                // ext:this.extensionValue ? this.extensionValue :  this.agentDetail.Extension,
                queues: queues,
                skills: skills,
                company: this.webStorageService.getItemFromSessionStorage('company'),
                user: this.webStorageService.getItemFromSessionStorage('currentUser'),
                wrapperOnly: this.isDesktopOnly,
                allowPopUps: this.allowPopUps
            };

            this.managerService
                .editAgentQueuesAndSkills(data)
                .pipe(
                    map((data: any) => {
                        const isValid = ResponseHandler.processResponse(data, 'EditAgentQueuesAndSkills');
                        if (isValid && data?.Response?.Message == null) {
                            this.reset();
                            this.location.back();
                        }else if(isValid && data?.Response?.Message != null){
                            this.editErrorMessage = data?.Response?.Message
                        }
                    }),
                    catchError(error => {
                        console.log(error);
                        return EMPTY;
                    })
                )
                .subscribe();
        }
    }

    }
    onSelectQueue(data: any) {
        this.modifiedQueueData = data;
    }
    onSelectSkill(data: any) {
        this.modifiedSkillData = data;
    }

    //Update the Live Status and enabled buttons
    getLiveStatus() {
        clearInterval(this.liveStatusTimer);
        this.managerService
            .GetLiveStatusByIDSilent(this.selectedAgentId)
            .pipe(
                map((data: any) => {
                    this.updateLiveStatus(data.Response.Data);
                }),
                catchError(error => {
                    console.log(error);
                    return EMPTY;
                })
            )
            .subscribe();
    }
    updateLiveStatus(data: any) {
        let hasStatus = (data != null);
        this.canStatusBeLoggedOff = (data != null) ? data.CanBeLoggedOff : false;
        this.currStatus = this.agentStatus.getStatusByID(hasStatus ? data.StatusID : this.agentStatus.Statuses.LoggedOut);
        let currStatus = this.currStatus;
        let currStatusLabel = currStatus.label;
        this.interactionHeader = (((currStatus == this.agentStatus.Statuses.OnCall || currStatus == this.agentStatus.Statuses.PostCall) ? 'CURRENT' : 'LAST') + ' INTERACTION');
        this.queueHeader = (((currStatus == this.agentStatus.Statuses.Away || currStatus == this.agentStatus.Statuses.LoggedOut || currStatus == this.agentStatus.Statuses.Disconnected) ? 'LAST' : 'CURRENT') + ' QUEUE');
        if (hasStatus && (data.LastInteractionTypeID == 7 || data.LastInteractionTypeID == 8)) {
            if (currStatus.id == 5) {
                currStatusLabel = "On Chat";
            } else if (currStatus.id == 8) {
                currStatusLabel = "Post Chat";
            }
        }
        if (currStatus.id == 11 && data.QueueType.toString().indexOf('Chat') != -1) {
            currStatusLabel = "Waiting For Chat";
        }
        this.currStatusLabel = currStatusLabel;
        this.isCustomLabel = false;
        if (hasStatus && currStatus.id == -1 && data.StatusID >= 5001) {
            this.currStatusLabel = data.Status;
            this.isCustomLabel = true;
        }
        this.agentStatusDuration = ((hasStatus) ? this.utils.formatDuration(data.Duration, 's', false, false, false) : '');
        this.agentStatusColor = currStatus.color;
        this.isPhoneQueue = ((hasStatus) ? data?.QueueName?.indexOf('Chat') == -1 : false);
        this.isAgentUsingWrapper = (hasStatus && data.AppClientType == "WindowsWrapper");
        this.isManagerUsingWrapper = this.OnvidaWrapper.IsWrapper;
        if (currStatus == this.agentStatus.Statuses.OnCall && this.isListeningIn && !this.isCallActive && !this.isConnecting) {
            var self = this;
            console.log("Listen In Sync"); 
        } else if (currStatus != this.agentStatus.Statuses.OnCall && this.isListeningIn && this.isCallActive) {
            console.log("Listen In Sync not OnCall", currStatus);
            this.listenInStop();
        } else if ((currStatus == this.agentStatus.Statuses.LoggedOut) && this.isLiveViewing) {
            console.log("Listen In Sync LoggedOut");
            this.listenInStop();
        } else {
            this.updateLiveStatusControls();
        }
        this.liveStatusTimer = setTimeout(() => { this.getLiveStatus(); }
            , (this.isListeningIn || this.isLiveViewing) ? this.liveStatusWaitShort : this.liveStatusWaitLong);

    }

    updateLiveStatusControls() {
        let currStatus = this.currStatus;
        var isAuditor = !this.ManageAgents && this.AuditAgents;
        let canLogOff = this.ManageAgents;
        if (!canLogOff || !this.canStatusBeLoggedOff) {
            canLogOff = false;
        } 
        this.CurrentStatus = ((this.ManageAgents || this.AuditAgents)
        && this.selectedAgentId != this.CurrentAgent.UserID
        && currStatus != this.agentStatus.Statuses.LoggedOut
        && currStatus != this.agentStatus.Statuses.Disconnected); 
        
        if (!this.isCustomLabel)
            this.CurrentStatus =  this.CurrentStatus && currStatus !=this.agentStatus.Statuses.Default;
        
        this.liveStatusControls =this.CurrentStatus;
        let isManager = this.canLiveView && !this.isManagerUsingWrapper && this.isAgentUsingWrapper;

        this.managerViewBtn = (isManager && !this.isLiveViewing);
        this.managerHideBtn = (isManager && this.isLiveViewing);
        this.managerListenBtn = (!this.isListeningIn && this.isPhoneQueue);

        this.managerDisconnectBtn = this.isListeningIn;
        this.managerRemoteLogoffBtn = (canLogOff);

        this.managerMuteOnBtn = (!isAuditor && this.isListeningIn && !this.isMuted && !this.isConnecting);
        this.managerMuteOffBtn = (!isAuditor && this.isListeningIn && this.isMuted && !this.isConnecting);
    }

    fetchGrands() { 
        this.canLiveView = this.securityService.validateGrant('LiveView');
        this.ManageAssignments = this.securityService.validateGrant('ManageAssignments');
        this.AuditAgents = this.securityService.validateGrant('AuditAgents');
        this.ManageAgents = this.securityService.validateGrant('ManageAgents');
        this.Admin = this.securityService.validateGrant('Admin');
        this.CurrentAgent = this.webStorageService.getItemFromSessionStorage('currentUser');
        this.clientAbbr = this.webStorageService.getItemFromSessionStorage('company');
        
    }
    RemoteLogOff() {
        this.confirmDialogComponent
            .confirmdialog('Remote Log Off', 'You are about to forcibly log out a user that is logged in to the application! Do you want to continue?', 'Yes', 'No')
            .then((confirmed) => {
                if (confirmed) {
                    this.listenInStop();
                    this.managerService
                        .remotelogoff(this.selectedAgentId)
                        .pipe(
                            map((data: any) => {

                            }),
                            catchError(error => {
                                console.log(error);
                                return EMPTY;
                            })
                        )
                        .subscribe();
                }
            })
            .catch(() =>
                console.log(
                    'User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'
                )
            );
    }
    delay(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }
    listenInStart(mgrController: any, listenNow: boolean) {
        var softphonestatus = this.mainController.getSoftPhoneStatus();
        if (listenNow && (softphonestatus == 'Ready' || softphonestatus == 'Active')) {
            //listenInTries = 0;
            this.listenInToCall();
        }
        else {
            console.log('livestatus - softphone initializing');
        }
    }
    listenInToCall() {

    }
    listenInPrep() {
        this.loaderService.display(true);
        var timeToDelay = this.mainController.CheckLastCallCompletedTimeBeforeCall();
        console.log('TimetoDelaycall', timeToDelay);
        (async () => {
            console.log('Before delay', new Date());
            
            await this.delay(timeToDelay); // 1-second delay
            console.log('After delay', new Date());
            

        this.isConnecting = true;
        this.isListeningIn = true;
        this.isMuted = true;
        this.managerService.JoinAgentsCall(this.selectedAgentId, 0)
            .pipe(map((data: any) => {
                this.listenInSuccess(data.Response.Data);
                this.loaderService.display(false);
            }),
                catchError(error => {
                    this.listenInFailure(error, error);
                    this.loaderService.display(false);
                    console.log(error);
                    return EMPTY;
                })
        ).subscribe();

         })();
    }
    listenInSuccess = function (response: any) {
        if (response != null) {
            console.log("ListenIn Call Started: " + response.ConferenceID);
            this.isCallActive = true;
            this.isConnecting = false;
            this.mainController.eListentInHandler(this.isMuted, this.isListeningIn);
            this.updateLiveStatusControls();
        } else {
            this.listenInFailure(null, null);
        }
    }

    listenInFailure(errorCode: any, message: any) {
        //window.clearTimeout(this.listenInConnectionTimeout);
        console.log("ListenIn Join Error: " + message);
        this.listenInStop();
    }
    listenInStop() {
        this.mainController.endCall(false, false);
        //this.mainController.initializeSoftPhone();
        this.mainController.setLastCallCompletedTime(new Date());
        
        this.isCallActive = false;
        this.isMuted = false;
        this.isListeningIn = false;
        this.mainController.eListentInHandler(this.isMuted, this.isListeningIn);
        this.updateLiveStatusControls();
      
    }
    muteStart = function () {
        if (this.isListeningIn && !this.isMuted)
            console.log('Barge Ended.')
        this.mainController.muteUnmuteMic(true);
        this.isMuted = true;
        this.updateLiveStatusControls();
        this.processingRequest = false;
    }
    muteStop = function () {
        this.confirmDialogComponent
            .confirmdialog('Remote Log Off', 'Are you sure? Unmuting will change your review mode from Listen In to Barge.', 'Ok', 'Cancel')
            .then((confirmed) => {
                if (confirmed) {
                    console.log('Barge Started...')
                    this.mainController.muteUnmuteMic(false);
                    this.isMuted = false;
                    this.updateLiveStatusControls();
                    this.processingRequest = false;
                }
            })
            .catch(() =>
                console.log(
                    'User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'
                )
            );
    }
    eManagerMuteBtnClickHandler() {
        if (this.isMuted)
            this.muteStop();
        else
            this.muteStart();
    }
    isListening() {
        return this.isListeningIn;
    }
    Startlivemoniter() {
        const initialState = {
            AgentName: this.title,
            AgentId: this.selectedAgentId,
            managerId: this.CurrentAgent.UserID,
            clientName: this.clientAbbr?.toLowerCase(),
            managerAPI: this.managerService
        };
        const config: ModalOptions = {
            backdrop: 'static',
            keyboard: false, class: '', initialState
        };
        this.modalRef = this.modalService.show(ManagerLiveMoniterComponent, config);
    }
    Stoplivemoniter() {
        this.bsModalRef.hide();
    }
    reset() {
        this.ManageAssignments = false;
        this.AuditAgents = false;
        this.ManageAgents = false;
        this.Admin = false;
        this.canStatusBeLoggedOff = null;
        this.isAgentUsingWrapper = false;
        this.isManagerUsingWrapper = false;
        this.isLiveViewing = false;
        this.isListeningIn = false;
        this.isCallActive = false;
        this.isConnecting = false;
        this.liveStatusWaitShort = 5000;
        this.liveStatusWaitLong = 10000;
        this.liveStatusTimer;
        this.currStatusLabel = '';
        this.agentStatusDuration = '';
        this.agentStatusColor = '';
        this.liveStatusControls = false;
        this.managerViewBtn = false;
        this.managerHideBtn = false;
        this.managerListenBtn = false;
        this.managerDisconnectBtn = false;
        this.managerRemoteLogoffBtn = false;
        this.managerMuteOnBtn = false;
        this.managerMuteOffBtn = false;
        this.CurrentAgent = null;
        this.currStatus = null;
        this.isMuted = false;
        this.isDesktopOnly = false;
        this.allowPopUps = false;
        this.mainController.setLastCallCompletedTime(null);
        this.mainController.eListentInHandler(this.isMuted, this.isListeningIn);
        clearInterval(this.liveStatusTimer);
    }
    ngOnDestroy() {
        //console.log('ngOnDestroy');
       // if (this.isCallActive)
            this.listenInStop();
        this.reset();
        //if (this.mainController.getSoftPhoneStatus() == 'Initializing...')
        //    this.mainController.initializeSoftPhone();
        this.liveStatusTimer && clearTimeout(this.liveStatusTimer);
    } 
}
